import { TaskData } from '../../../models';
import feedback from '../../../assets/feedback.svg';
import { FeedbackCard } from './FeedbackCard';
import { useTranslation } from 'react-i18next';

const createAnswerBlock = (data: TaskData) => {
  const { type, answer, question } = data;
  if (type === 'image') {
    return (
      <div className="h-[40vh] w-full">
        <img
          alt="answer"
          src={answer}
          className="m-auto h-full w-full object-contain"
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <span>Q: {question}</span>
      <span className="bg-gray-300 font-semibold text-xl flex-grow rounded-[50px] py-2 px-3">
        A: {answer}
      </span>
    </div>
  );
};
export function TaskCard({
  data,
  openFeedbackModal,
}: {
  data: TaskData;
  openFeedbackModal: (data: TaskData) => void;
}) {
  const [t] = useTranslation(['chatroom']);
  const handleClick = () => {
    openFeedbackModal(data);
  };
  return (
    <div className="border-b-2 bg-white">
      {data.hasFeedback ? (
        <FeedbackCard taskData={data} />
      ) : (
        createAnswerBlock(data)
      )}
      <button
        className="mt-4 bg-manage-sub rounded-3xl mb-4 text-white w-2/5 flex justify-center py-2 gap-4 disabled:bg-opacity-50"
        disabled={data.hasFeedback}
        onClick={handleClick}
      >
        {t('share_feedback', '分享回饋')}
        <img className="mt-1" alt="feedback" src={feedback} />
      </button>
    </div>
  );
}
